import { Disclosure, Transition } from "@headlessui/react";
import { FaqQuestion } from "@ui/components/faqs/types";
import { Icon } from "@ui/components/icon/icon";
import { cx } from "@uxf/core/utils/cx";
import React, { FC } from "react";

export const FaqDropdownTile: FC<FaqQuestion> = ({ answer, question }) => (
    <Disclosure as="div" className="h-min">
        {({ open }) => (
            <>
                <Disclosure.Button
                    className={cx(
                        "ui-typo-medium relative flex min-h-[6rem] w-full items-center justify-between px-6 py-2 text-left text-primary focus:outline-none",
                        "before:pointer-events-none before:absolute before:inset-0 before:border-2 before:border-transparent",
                        "focus-visible:before:border-uxfViolet/50",
                    )}
                >
                    <div className="mr-4 md:-ml-6">{question}</div>
                    <Icon
                        className={`transition duration-200 ${open ? "text-uxfViolet" : "text-uxfLightGray"}`}
                        name={open ? "minus" : "plus"}
                        size={24}
                    />
                </Disclosure.Button>
                <Transition
                    enter="transition duration-100 ease-out"
                    enterFrom="transform scale-90 opacity-0"
                    enterTo="transform scale-100 opacity-100"
                    leave="transition duration-100 ease-out"
                    leaveFrom="transform scale-100 opacity-100"
                    leaveTo="transform scale-90 opacity-0"
                >
                    <Disclosure.Panel className="ui-typo-body mt-2 px-6 pb-7 text-uxfMuted75 transition md:pl-14">
                        {answer}
                    </Disclosure.Panel>
                </Transition>
            </>
        )}
    </Disclosure>
);
